import React from 'react';
import ReactDOM from 'react-dom';
//import './createShadowRoot'
import retargetEvents from 'react-shadow-dom-retarget-events';
import "antd/dist/antd.css";
import "./styles/main.css";
import App from './App';
import { LocaleProvider } from 'antd';
import frFR from 'antd/lib/locale-provider/fr_FR';
import 'moment/locale/fr';

const shadowRoot = document.getElementById('gRoot').shadowRoot;
let reactRoot = document.createElement('div');
reactRoot.setAttribute('id', 'react-root');

if(shadowRoot) {
	retargetEvents(shadowRoot);
	shadowRoot.appendChild(reactRoot);
} else {
	document.querySelector('#gRoot').appendChild(reactRoot)
}
ReactDOM.render(<LocaleProvider locale={frFR}>
	<App />
</LocaleProvider>, reactRoot);

